import { isNil } from '@lucidlink/tscore';
import { InvalidArgumentError } from '#common/types';
const DEFAULT_SET_LOCATION_CONSTRAINT = false;
const DEFAULT_USE_VIRTUAL_ADDRESSING = false;
export function createS3Config(config, stsContext) {
    const result = doCreateConfig(config, stsContext);
    return result;
}
function doCreateConfig(config, stsContext) {
    const result = createS3ConfigWithDefaults(config);
    if (!isNil(config.setLocationConstraint)) {
        result.setLocationConstraint = config.setLocationConstraint;
    }
    if (!isNil(config.useVirtualAddressing)) {
        result.useVirtualAddressing = config.useVirtualAddressing;
    }
    if (!isNil(config.endpointOverride)) {
        result.endpointOverride = config.endpointOverride;
    }
    if (!isNil(config.region)) {
        result.region = config.region;
    }
    if (!isNil(config.storageClass)) {
        result.storageClass = config.storageClass;
    }
    if (!isNil(stsContext)) {
        result.stsContext = stsContext;
    }
    return result;
}
function createS3ConfigWithDefaults(config) {
    if (isNil(config.credentials)) {
        throw new InvalidArgumentError('Missing object store credentials');
    }
    return {
        httpScheme: config.httpScheme,
        provider: config.provider,
        credentials: config.credentials,
        setLocationConstraint: DEFAULT_SET_LOCATION_CONSTRAINT,
        useVirtualAddressing: DEFAULT_USE_VIRTUAL_ADDRESSING,
    };
}
